import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";
export const GENERAL_QUERY_KEY = "generalQuery";

export const useProfileGeneralQuery = (patientUserId) => {
  return useQuery({
    queryKey: [GENERAL_QUERY_KEY,patientUserId],
    retry: false,
    queryFn:  getGeneral.bind(this,patientUserId),
    placeholderData: [],
    enabled: !!patientUserId
  });
};

const getGeneral = async (patientUserId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "pcmedapi",
    path: "/profile/general/" + patientUserId,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};